import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Injector, inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { OtsCartService } from '../services/OtsCartService';
import { OtsGuestNoticeService } from '../services/OtsGuestNoticeService';
import { OtsSessionService } from '../services/OtsSessionService';
import { OtsContextStore } from '../stores/OtsContextStore';
import { OtsOrderStore } from '../stores/OtsOrderStore';
import { environment } from '../../../../../environments/environment';

const isOtsGuestApiUrl = (url: string): boolean => url.startsWith(environment.otsApiBase.replace(/\/$/, ''));

export const otsGuestAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const otsContextStore = inject(OtsContextStore);
  const injector = inject(Injector);

  let request = req;
  if (isOtsGuestApiUrl(req.url)) {
    const session = otsContextStore.session();
    if (session?.guestId && session.accessToken) {
      request = req.clone({
        setHeaders: {
          'X-Guest-Id': session.guestId,
          'X-Guest-Token': session.accessToken
        }
      });
    }
  }

  return next(request).pipe(
    catchError((error: unknown) => {
      if (
        error instanceof HttpErrorResponse
        && isOtsGuestApiUrl(request.url)
        && injector.get(OtsGuestNoticeService).isSessionAuthError(error)
      ) {
        const sessionService = injector.get(OtsSessionService);
        const cart = injector.get(OtsCartService);
        const order = injector.get(OtsOrderStore);
        const router = injector.get(Router);

        sessionService.clearSession();
        cart.clear();
        order.order.set(null);
        void router.navigate(['/order-to-seat', 'error'], { queryParams: { code: 'session' } });
      }

      return throwError(() => error);
    })
  );
};
